module.exports = __webpack_public_path__ + "img/good-active.e15fed0c.svg";